module.exports = __webpack_public_path__ + "static/media/notes2.e7c3f74f.png";